import request from '@/utils/request'

// 挪车记录
export function GetMoveTask(data) {
  return request({
    url: '/api/app/move-task',
    method: 'get',
    params: data
  })
}

// 挪车统计
export function GetMoveTaskStatistics(data) {
  return request({
    url: '/api/app/move-task/statistics',
    method: 'get',
    params: data
  })
}

// 获取挪车数据详情
export function GetMoveTaskDetail(data) {
  return request({
    url: `/api/app/move-task/${data.id}`,
    method: 'get',
    params: data
  })
}

// 审核挪车数据
export function AuditMoveTask(data) {
  return request({
    url: '/api/app/move-task/audit',
    method: 'post',
    data
  })
}

// 获取挪车处理默认配置
export function GetMoveTaskHandleConfig() {
  return request({
    url: `/api/app/move-task/handle-config`,
    method: 'get'
  })
}

// 处理挪车相关的状态
export function HandleMoveTask(data) {
  return request({
    url: '/api/app/move-task/handle',
    method: 'post',
    data
  })
}

// 获取指定条件的服务区列表
export function GetMoveTaskArea(data) {
  return request({
    url: `/api/app/move-task/areas`,
    method: 'get',
    params: data
  })
}

// 站点统计
export function GetMoveTaskParks(data) {
  return request({
    url: '/api/app/move-task/park-statistics',
    method: 'get',
    params: data
  })
}

// 获取挪车开始定位数据
export function GetMoveTaskStartLocations(data) {
  return request({
    url: `/api/app/move-task/start-location/${data.cardId}`,
    method: 'get',
    params: data
  })
}

// 获取挪车结束定位数据
export function GetMoveTaskEndLocations(data) {
  return request({
    url: `/api/app/move-task/end-location/${data.cardId}`,
    method: 'get',
    params: data
  })
}

// 获取定位数据
export function GetMoveTaskLocations(data) {
  return request({
    url: `/api/app/move-task/locations`,
    method: 'get',
    params: data
  })
}

/********************** 换电数据 **********************/
// 换电服务区
export function GetBatteryChangeAreas(data) {
  return request({
    url: '/api/app/battery-change-task/areas',
    method: 'get',
    params: data
  })
}

// 换电数据
export function GetBatteryData(data) {
  return request({
    url: '/api/app/battery-change-task',
    method: 'get',
    params: data
  })
}

// 换电统计
export function GetBatteryStatistics(data) {
  return request({
    url: '/api/app/battery-change-task/statistics',
    method: 'get',
    params: data
  })
}

// 换电审核
export function AuditBatteryTask(data) {
  return request({
    url: '/api/app/battery-change-task/audit',
    method: 'post',
    data
  })
}

// 获取换电处理默认配置
export function GetBatteryChangeHandleConfig() {
  return request({
    url: `/api/app/battery-change-task/handle-config`,
    method: 'get'
  })
}

// 换电处理
export function HandleBatteryTask(data) {
  return request({
    url: '/api/app/battery-change-task/handle',
    method: 'post',
    data
  })
}

/********************** 维修数据 **********************/
// 维修统计
export function GetMaintenanceStatistics(data) {
  return request({
    url: '/api/app/maintenance-log/statistics',
    method: 'get',
    params: data
  })
}

// 维修服务区
export function GetMaintenanceAreas(data) {
  return request({
    url: '/api/app/maintenance-log/areas',
    method: 'get',
    params: data
  })
}

// 维修数据
export function GetMaintenanceData(data) {
  return request({
    url: '/api/app/maintenance-log',
    method: 'get',
    params: data
  })
}

// 维修审核
export function AuditMaintenanceTask(data) {
  return request({
    url: '/api/app/maintenance-log/audit',
    method: 'post',
    data
  })
}

// 获取维修处理默认配置
export function GetMaintenanceHandleConfig() {
  return request({
    url: `/api/app/maintenance-log/handle-config`,
    method: 'get'
  })
}

// 维修处理
export function HandleMaintenanceTask(data) {
  return request({
    url: '/api/app/maintenance-log/handle',
    method: 'post',
    data
  })
}

/********************** 查询挪车、换电、维修的修改规则日志 **********************/
export function GetOperatorHandleLogs(data) {
  return request({
    url: `/api/app/operator-handle-log/handle-logs`,
    method: 'get',
    params: data
  })
}

// 设置客户街道分区配置数据
export function SetCustomerAreaConfig(data) {
  return request({
    url: '/api/app/customer-area/config?area=' + data.area,
    method: 'put',
    data: data.data
  })
}

// 获取客户街道分区配置数据
export function GetCustomerAreaConfig(data) {
  return request({
    url: '/api/app/customer-area/config',
    method: 'get',
    params: data
  })
}

// 获取客户对账统计订单信息
export function GetCustomerAreaOrders(data) {
  return request({
    url: '/api/app/customer-area/orders',
    method: 'get',
    params: data
  })
}

// 行程单
export function createTravel(data) {
  return request({
    url: '/api/app/travel',
    method: 'post',
    data
  })
}

export function resetTravel(data) {
  return request({
    url: `/api/app/travel/${data.id}/reset`,
    method: 'post',
    data
  })
}

export function getTravel(data) {
  return request({
    url: '/api/app/travel',
    method: 'get',
    params: data
  })
}

export function getTravelDetail(data) {
  return request({
    url: '/api/app/travel/details',
    method: 'get',
    params: data
  })
}